import createClient from "openapi-fetch";
import {paths} from "./v1";

export function apiClient() {
    return createClient<paths>({
        baseUrl: process.env.REACT_APP_API_HOST
    })
}